import { AppAd } from "./ad";

export class AdDisplay extends AppAd {
    constructor() {
        super({
            logLabel: 'AdDisplay'
        });
    }

    get extraInsStyles(): string {
        if (this.hasAttribute('extraInsStyles')) {
            const attr = this.getAttribute('extraInsStyles');
            return ' ' + attr;
        }
        return '';
    }

    get adFormat(): string {
        if (this.hasAttribute('adFormat')) {
            const attr = this.getAttribute('adFormat');
            return attr;
        }
        return 'auto';
    }

    buildHtml() {
        return `
            <ins class="adsbygoogle"
                style="display: block; text-align: center;${this.extraInsStyles}"
                data-ad-client="ca-pub-1557542376119618"
                data-ad-slot="${this.slotId}"
                data-ad-format="${this.adFormat}"
                data-full-width-responsive="true"
                ${this.lazyLoad ? 'data-loading="lazy"' : ''}>
            </ins>
        `;
    }
}
